import { VStack } from "@kazaar-platform/design-system";
import { RiSparklingLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { useFormContext } from "react-hook-form";
import { ControlledCombobox, ControlledTextField } from "@/components/Form";
import { AttributeDtoTypeEnum } from "@/config/apiClient";
import { type BriefSummaryFormsProps } from "../BriefSummary.types";
import IAEditableField from "./IAEditableField";

export const BriefSummaryFieldsForm = ({
  initialAIValues,
  productAttributes,
  formResetKey,
}: BriefSummaryFormsProps) => {
  const { t } = useTranslate();

  const formMethods = useFormContext();

  const fields = formMethods.watch("fields");

  return (
    <VStack gap="sp-sm">
      <div className="grid grid-cols-2 gap-4 auto-rows-auto">
        {productAttributes?.attributes?.map((attribut) => {
          const potentielEnumValue = attribut?.values?.find(
            (e) => e.idAdma === fields[attribut.idAdma]?.value
          );

          const translatedEnumValue = potentielEnumValue
            ? t(potentielEnumValue.label)
            : "";

          const value =
            attribut.type !== AttributeDtoTypeEnum.DropdownList
              ? fields[attribut.idAdma]?.value || ""
              : translatedEnumValue;

          return (
            <IAEditableField
              key={attribut.idAdma + value}
              label={t(attribut.label)}
              value={value || undefined}
              IAValue={
                initialAIValues?.fields &&
                initialAIValues.fields[Number(attribut.idAdma)]?.value ===
                  fields[attribut.idAdma]?.value
                  ? value
                  : undefined
              }
            >
              {attribut.type === AttributeDtoTypeEnum.Text && (
                <ControlledTextField name={`fields.${attribut.idAdma}.value`} />
              )}

              {attribut.type === AttributeDtoTypeEnum.DropdownList && (
                <ControlledCombobox
                  key={`field-${attribut.idAdma}-${formResetKey}`}
                  options={
                    attribut.values?.map((e) => ({
                      label: t(e.label),
                      id: String(e.idAdma),
                      name: t(e.label),
                      textValue: `${e.idAdma}`,
                      badge:
                        initialAIValues?.fields &&
                        initialAIValues?.fields[Number(attribut.idAdma)]
                          ?.value === e?.idAdma
                          ? {
                              state: "primary",
                              label: "AI",
                              iconLeft: RiSparklingLine,
                            }
                          : undefined,
                    })) || []
                  }
                  name={`fields.${attribut.idAdma}.value`}
                />
              )}

              {(attribut.type === AttributeDtoTypeEnum.Numerical ||
                attribut.type === AttributeDtoTypeEnum.Decimal) && (
                <ControlledTextField
                  type="number"
                  name={`fields.${attribut.idAdma}.value`}
                />
              )}
            </IAEditableField>
          );
        })}
      </div>
    </VStack>
  );
};
